import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["password", "icon"]

  toggle() {
    const field = this.passwordTarget
    const iconWrapper = this.iconTarget
    const icon = iconWrapper.querySelector("i")
  
    const isHidden = field.type === "password"
    field.type = isHidden ? "text" : "password"
  
    icon.classList.toggle("bi-eye")
    icon.classList.toggle("bi-eye-slash")
  }
  
}